import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// Login Redux States
import { CHECK_LOGIN, LOGOUT_USER, REQUEST_OTP_USER, SWITCH_USER, VERIFY_ADMIN } from './actionTypes';
import { apiError, loginUserSuccessful, logoutUserSuccess, requestOtpUserFail, requestOtpUserSuccess, switchUserFail, switchUserSuccess, verify_adminFail, verify_adminSuccess } from './actions';
import { push } from 'connected-react-router'; // Import the push function from connected-react-router

// AUTH related methods
import { loginApi, logoutApi, requestOTPApi, switchUserApi, verifyAdminApi } from './api';
import Helpers from '../../../helpers/helpers';

//If user is login then dispatch redux action's are directly from here.

function* loginUser({ payload: { user, history, rememberMe } }) {
    try {
        const response = yield call(loginApi, user)
        // localStorage.setItem("authUser", JSON.stringify(response.data.profile));
        if (rememberMe) {
            localStorage.setItem("token", JSON.stringify(response.token));
        } else {
            sessionStorage.setItem("token", JSON.stringify(response.token));
            localStorage.setItem("token", JSON.stringify(response.token));
            setTimeout(() => {
                localStorage.removeItem("token")
            }, 30000000)
        }
        yield put(loginUserSuccessful(response));

        // history('/dashboard');
    } catch (error) {
        yield put(apiError(error));
    }
}

function* logoutUser({ payload }) {
    try {

        const response = yield call(logoutApi, payload);
        yield put(logoutUserSuccess(response));
        localStorage.removeItem('token');
        sessionStorage.removeItem('token')
        if (!payload?.notDirectToLogin) Helpers.routeToLogin();
        // history('/login');
    } catch (error) {
        yield put(apiError(error));
        if (!payload?.notDirectToLogin) Helpers.routeToLogin();
    }
}

function* verifyAdmin({ payload: { history } }) {
    try {
        const response = yield call(verifyAdminApi);
        if (response.code === "success") {
            yield put(verify_adminSuccess(response));
        } else {
            yield put(verify_adminFail(response));
            localStorage.removeItem('token');
            // yield put(push('/login'));
            return false
        }
    } catch (error) {
        yield put(apiError(error));
    }
}

function* requestOTP({ payload }) {
    try {
        const response = yield call(requestOTPApi, payload);
        if (response.code === "success") {
            yield put(requestOtpUserSuccess(response));
        } else {
            yield put(requestOtpUserFail(response));
            return false
        }
    } catch (error) {
        yield put(apiError(error));
    }
}

function* switchUser({ payload }) {
    try {
        const response = yield call(switchUserApi, payload);
        if (response.code === "success") {
            yield put(switchUserSuccess(response));
        } else {
            yield put(switchUserFail(response));
            return false
        }
    } catch (error) {
        yield put(switchUserFail(error));
        yield put(apiError(error));
    }
}

export function* watchUserLogin() {
    yield takeEvery(CHECK_LOGIN, loginUser);
}

export function* watchUserLogout() {
    yield takeEvery(LOGOUT_USER, logoutUser);
}

function* loginSaga() {
    yield all([
        fork(watchUserLogin),
        fork(watchUserLogout),
    ]);
    yield takeEvery(VERIFY_ADMIN, verifyAdmin)
    yield takeEvery(REQUEST_OTP_USER, requestOTP)
    yield takeEvery(SWITCH_USER, switchUser)

}

export default loginSaga;